import { USE_WHITELABEL_BRANDING, WHITELABEL_KEY, type WhitelabelKey } from "./globals";

export interface BrandingConfig {
  logo: string;
  searchStatusImage: string;
  headerImage: string;
  mobileHeaderImage: string;
  mobileHeaderImageHighContrast: string;
  faviconPrefix: string;
  title: string;
}

export const brandingConfig: Record<WhitelabelKey, BrandingConfig> = {
  nj: {
    logo: "assets/images/myhealthnj_logo.png",
    headerImage: "assets/images/myhealthnj_logo_white.png",
    searchStatusImage: "/assets/images/nj-logo-blue.png",
    mobileHeaderImage: "assets/images/myhealthnj_logo.png",
    mobileHeaderImageHighContrast: "assets/images/myhealthnj_logo.png",
    faviconPrefix: "/nj-favicon",
    title: "MyHealthNJ | Docket®",
  },
  /* default "docket" styles */
  default: {
    logo: "assets/images/Docket_Logo_Blue.png",
    headerImage: "assets/images/Docket_Logo_White.png",
    searchStatusImage: "/assets/images/Docket_Jim_Light.png",
    mobileHeaderImage: "assets/images/Docket_Logo_White.png",
    mobileHeaderImageHighContrast: "assets/images/Docket_Logo_Blue.png",
    faviconPrefix: "",
    title: "Docket®",
  },
};

/** The branding for the domain the app is running on. */
export const branding: BrandingConfig = USE_WHITELABEL_BRANDING
  ? // eslint-disable-next-line security/detect-object-injection -- WHITELABEL_KEY is a typed union
    brandingConfig[WHITELABEL_KEY] || brandingConfig["default"]
  : brandingConfig["default"];
